// extracted by mini-css-extract-plugin
export var attribution = "_aa-4";
export var authorName = "_aa-5";
export var quote = "_aa-3";
export var testimonial = "_aa-2";
export var trustedBy = "_aa-0";
export var trustedByLabel = "_aa-1";